import { Component, OnInit } from "@angular/core";
import { NzModalRef } from "ng-zorro-antd/modal";

@Component({
  selector: "v4-connect-with-douyin",
  templateUrl: "./connect-with-douyin.component.html",
  styleUrls: ["./connect-with-douyin.component.scss"],
})
export class V4ConnectWithDouyinComponent implements OnInit {
  constructor(private modalRef: NzModalRef) {}

  ngOnInit() {}

  onCancel() {
    this.modalRef.close();
  }

  // quick sort

  onFinish() {
    this.modalRef.close("contact");
  }
}
